/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeasonProgressionSourceType } from './SeasonProgressionSourceType';
import {
    SeasonProgressionSourceTypeFromJSON,
    SeasonProgressionSourceTypeFromJSONTyped,
    SeasonProgressionSourceTypeToJSON,
    SeasonProgressionSourceTypeToJSONTyped,
} from './SeasonProgressionSourceType';

/**
 * 
 * @export
 * @interface SeasonProgressionRule
 */
export interface SeasonProgressionRule {
    /**
     * 
     * @type {SeasonProgressionSourceType}
     * @memberof SeasonProgressionRule
     */
    sourceType: SeasonProgressionSourceType;
    /**
     * QUEST_COMPLETION — only these quests count. Absent = any quest.
     * @type {Array<string>}
     * @memberof SeasonProgressionRule
     */
    questConfigIds?: Array<string>;
    /**
     * GAME_SESSION — only these games count. Absent = any game.
     * @type {Array<string>}
     * @memberof SeasonProgressionRule
     */
    gameIds?: Array<string>;
    /**
     * HUB-scoped passes — the hub this rule applies to. Also used by BRAND_ACTIVATION for activations scoped to a hub.
     * @type {string}
     * @memberof SeasonProgressionRule
     */
    surfaceId?: string;
    /**
     * BRAND_ACTIVATION — only these specific activations count.
     * @type {Array<string>}
     * @memberof SeasonProgressionRule
     */
    activationIds?: Array<string>;
    /**
     * BADGE_OWNERSHIP — NftGrouping the user must hold to earn the one-time XP grant.
     * @type {string}
     * @memberof SeasonProgressionRule
     */
    badgeNftGroupingId?: string;
    /**
     * BADGE_OWNERSHIP — fixed XP credited on enrollment if badge is held.
     * @type {number}
     * @memberof SeasonProgressionRule
     */
    badgeXpGrant?: number;
    /**
     * GAME_SESSION — minimum session duration in minutes to qualify.
     * @type {number}
     * @memberof SeasonProgressionRule
     */
    minDurationMinutes?: number;
    /**
     * Max times this rule can contribute XP per user. 1 for BADGE_OWNERSHIP. Absent = unlimited.
     * @type {number}
     * @memberof SeasonProgressionRule
     */
    maxClaims?: number;
}



/**
 * Check if a given object implements the SeasonProgressionRule interface.
 */
export function instanceOfSeasonProgressionRule(value: object): value is SeasonProgressionRule {
    if (!('sourceType' in value) || value['sourceType'] === undefined) return false;
    return true;
}

export function SeasonProgressionRuleFromJSON(json: any): SeasonProgressionRule {
    return SeasonProgressionRuleFromJSONTyped(json, false);
}

export function SeasonProgressionRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonProgressionRule {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceType': SeasonProgressionSourceTypeFromJSON(json['sourceType']),
        'questConfigIds': json['questConfigIds'] == null ? undefined : json['questConfigIds'],
        'gameIds': json['gameIds'] == null ? undefined : json['gameIds'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'activationIds': json['activationIds'] == null ? undefined : json['activationIds'],
        'badgeNftGroupingId': json['badgeNftGroupingId'] == null ? undefined : json['badgeNftGroupingId'],
        'badgeXpGrant': json['badgeXpGrant'] == null ? undefined : json['badgeXpGrant'],
        'minDurationMinutes': json['minDurationMinutes'] == null ? undefined : json['minDurationMinutes'],
        'maxClaims': json['maxClaims'] == null ? undefined : json['maxClaims'],
    };
}

export function SeasonProgressionRuleToJSON(json: any): SeasonProgressionRule {
    return SeasonProgressionRuleToJSONTyped(json, false);
}

export function SeasonProgressionRuleToJSONTyped(value?: SeasonProgressionRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceType': SeasonProgressionSourceTypeToJSON(value['sourceType']),
        'questConfigIds': value['questConfigIds'],
        'gameIds': value['gameIds'],
        'surfaceId': value['surfaceId'],
        'activationIds': value['activationIds'],
        'badgeNftGroupingId': value['badgeNftGroupingId'],
        'badgeXpGrant': value['badgeXpGrant'],
        'minDurationMinutes': value['minDurationMinutes'],
        'maxClaims': value['maxClaims'],
    };
}

